import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function TextBlock({
    width = 'lg',
    className,
    alignX = 'left',
    textAlign = 'left',
    children,
    ...rest
}) {
    return (
        <div
            data-component={`TextBlock TextBlock-${width}`}
            className={cx('sarsa-text-block', alignX, `text-align-${textAlign}`, className, {
                sm: width === 'sm',
                md: width === 'md',
                lg: width === 'lg',
                xl: width === 'xl'
            })}
            {...rest} >
            {children}
        </div>
    );
}


TextBlock.propTypes = {
    /** Text contents */
    children: PropTypes.node,

    /** Width to be constrained to (based on character count) */
    width: PropTypes.oneOf(['none', 'sm', 'md', 'lg', 'xl']),

    /** If true, block is centered in its container */
    alignX: PropTypes.oneOf(['left', 'center', 'right']),

    /** If true, block is centered in its container */
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),

    /** Additional class added to the outer container */
    className: PropTypes.string
};
